import { useAction } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { currencyAddLogoEvent } from '../../atoms'

import type { CurrencyModel } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  currency: CurrencyModel
  size?: number
  padding: number
  onClickOverride?: (currency: CurrencyModel) => void
} & ClassNameProps
export const PremiumLogoFallback: React.FC<Props> = ({
  size = 62,
  currency,
  className,
  padding,
  onClickOverride,
}) => {
  const handleAddLogo = useAction(currencyAddLogoEvent)

  const plusSize = size / 2.7

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    const callback = onClickOverride ?? handleAddLogo
    callback(currency)
  }

  const style = useMemo(
    (): React.CSSProperties => ({
      width: size,
      height: size,
      padding: padding,
    }),
    [size, padding],
  )

  return (
    <Root style={style} onClick={handleClick} className={className}>
      <Circle>
        <GradientPlusIcon size={plusSize} />
      </Circle>
    </Root>
  )
}

const Root = styled.div`
  background: var(--backgroundA-2);
  border-radius: inherit;
  position: relative;
  cursor: pointer;
`

const Circle = styled.div`
  border: 1px dashed var(--backgroundA-6);

  border-radius: inherit;
  width: 100%;
  height: 100%;

  display: grid;
  place-items: center;
  align-content: center;
  transition: all 200ms linear;

  &:hover {
    border: 1px dashed var(--backgroundA-9);

    svg {
      transform: scale(1.2);
    }
  }
`

const GradientPlusIcon = ({ size }: { size: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2871 21.9501V1.4751"
        stroke="url(#paint0_linear_9310_3334)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21.5248 11.7126L1.0498 11.7126"
        stroke="url(#paint1_linear_9310_3334)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9310_3334"
          x1="11.7871"
          y1="1.4751"
          x2="11.7871"
          y2="21.9501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--subscriptionGradientFrom-9)" />
          <stop offset="1" stopColor="var(--subscriptionGradientTo-9)" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9310_3334"
          x1="1.0498"
          y1="11.2126"
          x2="21.5248"
          y2="11.2126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--subscriptionGradientFrom-9)" />
          <stop offset="1" stopColor="var(--subscriptionGradientTo-9)" />
        </linearGradient>
      </defs>
    </svg>
  )
}
